// @ts-strict-ignore
import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { LoadProjectService } from '@project/service/load-project.service';
import { RouteNavigationService } from '@services/route-navigation.service';
import { ProjectNavigationModel } from '../project-navigation.model';
import { ProjectHeadVO } from '@project/model/vo/project.vo';
import { Log } from '@shared/debug/log';
import { ProjectNavigationService } from '../service/project-navigation.service';
import { UserSettings } from '@user/model/user-settings';
import { ProjectNavigationAdditionalData } from '../project-navigation.presenter';
import { ProjectGroupLoadingService } from '@project/components/project/service/project-group-loading.service';
import { ProjectModel } from '@project/model/project.model';
import { ProjectUtils } from '@project/components/project/util/project-utils';

@Component({
  standalone: false,
  templateUrl: './load-project.component.html',
  selector: 'app-load-project',
})

export class LoadProjectComponent implements OnInit {
  @Input() data: ProjectNavigationAdditionalData;

  @Output() public finish = new EventEmitter<boolean>();

  @HostBinding(`class.d-flex`) displayFlexClass = true;
  @HostBinding(`class.flex-column`) flexDirectionClass = true;

  public model: ProjectNavigationModel;

  public submitEnabled = false;
  public visibleCompositeCheckBox = true;

  public constructor(
    private userSettings: UserSettings,
    private loadProjectService: LoadProjectService,
    private routeNavigationService: RouteNavigationService,
    private projectNavigationService: ProjectNavigationService,
    private projectGroupLoadingService: ProjectGroupLoadingService,
    private projectModel: ProjectModel,
  ) {}

  public async ngOnInit() {
    this.model = new ProjectNavigationModel();
    this.model.currentModel = {
      importType: null,
      lastSelectedGroupId: this.userSettings.lastSelectedProjectGroupId,
      lastSelectedProjectId: this.userSettings.lastSelectedProjectId,
      visibleSharedProjects: true,
      visibleHiddenProjects: true,
    };
    this.model.openedFromDashboard = this.data.fromDashBoard;
    this.visibleCompositeCheckBox = this.projectNavigationService.isSaveLoadCompositeArticlesAvailable;
  }

  public async onInitializeSubComponent(): Promise<void> {
    if (this.data.fromDashBoard) {
      await this.projectNavigationService.openRecentlyUsedProjects(this.model);
      const lastSelectedProject = this.model.viewItems?.length > 0 ? this.model.viewItems[0] : undefined;
      if (lastSelectedProject) {
        this.model.preSelectItem(lastSelectedProject);
        this.model.scrollToSelected.next();
      }
    } else {
      if (ProjectUtils.isProjectSaved(this.projectModel.currentProject)) {
        const project = await this.projectGroupLoadingService.loadProjectGroupById(this.projectModel.currentProject.projectGroup.id, 1)
        if (project) {
          this.model.selectItem(this.projectModel.currentProject, this.projectModel);
        }
      }
      await this.projectNavigationService.openPreselectedProjectGroup(this.model);
    }
  }

  public updateSubmitEnabled(): void {
    this.submitEnabled = this.model.currentSelectedItem && this.model.currentSelectedItem instanceof ProjectHeadVO;
  }

  public async loadSelectedProject(): Promise<void> {
    if (!this.model.currentSelectedItem || !(this.model.currentSelectedItem instanceof ProjectHeadVO)) {
      return;
    }
    if(await this.loadProject(this.model.currentSelectedItem)) {
      this.finish.emit(true);
      if (this.data.navigateToConfigurator) {
        await this.routeNavigationService.toConfigurator();
      }
    }
  }

  private async loadProject(projectHead: ProjectHeadVO): Promise<boolean> {
    if (!projectHead) {
      return null;
    }
    if (projectHead.temporaryLinkGUID) {
      try {
        await this.loadProjectService.loadProjectByGuid(projectHead.temporaryLinkGUID);
        return true;
      } catch (error) {
        Log.error('Could not load project by guid: ', error);
      }
    } else {
      try {
        await this.loadProjectService.loadProject(projectHead, this.model.compositeCheckBoxValue);
        return true;
      } catch (error) {
        Log.error('Could not load project: ', error);
      }
    }
  }

  public cancel() {
    this.finish.emit(false);
  }
}
